export default __webpack_public_path__ + "locales/si/DataReassignmentDialog.json?hash=de01d89a6a13a4f50d16de47662897fa";